import { createAction } from '@reduxjs/toolkit';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const selectAffectationItemsAction = createAction(
  BaselineAffectationType.SelectAffectationItems,
  (baselineIds: OrderWorkunit['id'][]) => ({
    payload: { baselineIds },
  })
);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.SelectAffectationItems:
      return {
        ...state,
        selectedItems: action.payload.baselineIds,
      };
    default:
      return state;
  }
};
